/* eslint-disable jira/filename-case */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { RouteResource } from '@atlassian/react-resource-router';
import { transitioningDetailsResource } from './transitioningDetailsResource.tsx';
import type { TransitioningDetailsResponse } from './TransitioningDetailsResponse.types.tsx';

export const resources = (): RouteResource<TransitioningDetailsResponse>[] => [
	transitioningDetailsResource,
];
